export default {
    itemsWishlist: 0,
    countItemsWishlist: 0,
    pagination: null,
}
  